import { Paper, Typography, styled } from "@mui/material"

import { colors } from "theme"

export const Card = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "17px",
  padding: "0",
  [theme.breakpoints.up("lg")]: {
    margin: "0 16px",
    width: "530px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  color: colors.maastrichtBlue,
  borderRadius: "17px",
  fontSize: "18px",
  fontWeight: "500",
  justifyContent: "flex-start",
  lineHeight: "22px",
  textTransform: "initial",
  margin: "0",
  padding: "0",
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    backgroundColor: "transparent",
    fontWeight: "600",
    fontSize: "16px",
    justifyContent: "center",
  },
}))

export const Description = styled(Typography)(() => ({
  color: colors.black,
  fontSize: "0.875rem",
  fontWeight: "400",
  lineHeight: "1.6",
  margin: "0",
}))
